import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CustomProductListViewType } from "@midland-industries/Handlers/ProductList/CustomSetView";
import { Draft } from "immer";

/**
 * ChangeLog:
 * 20230412: DLD: Make 'Condensed' the default productList.view value.
 */
type CheckoutState = Readonly<{
    upsCollect: string;
    packingBasis: string;
}>;
type ProductListState = Readonly<{
    view: CustomProductListViewType;
}>;
type ProductDetailsState = Readonly<{
    customerPartNumber: string;
}>;

type CustomDataState = Readonly<{
    checkout: CheckoutState;
    productList: ProductListState;
    productDetails: ProductDetailsState;
}>;

const initialCustomDataState: CustomDataState = {
    checkout: { upsCollect: "", packingBasis: "" },
    productList: { view: "Condensed" },
    productDetails: { customerPartNumber: "" },
};

const customData = createTypedReducerWithImmer(initialCustomDataState, {
    "CustomData/ProductList/SetView": (draft: Draft<CustomDataState>, action: { view: CustomProductListViewType }) => {
        draft.productList.view = action.view;
    },
    "CustomData/ProductDetails/SetCustomerPartNumber": (
        draft: Draft<CustomDataState>,
        action: { customerPartNumber: string },
    ) => {
        draft.productDetails.customerPartNumber = action.customerPartNumber;
    },
    "CustomData/CheckoutReviewAndSubmit/SetPackingBasis": (
        draft: Draft<CustomDataState>,
        action: { packingBasis: string },
    ) => {
        draft.checkout.packingBasis = action.packingBasis;
    },
});

(reducers as any).customData = customData;

export type CustomState = {
    customData: CustomDataState;
} & ApplicationState;

type Reducers = {
    customData: typeof customData;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
